import { render } from "./TheHeaderMenu.vue?vue&type=template&id=597b6cd4&scoped=true"
import script from "./TheHeaderMenu.vue?vue&type=script&lang=js"
export * from "./TheHeaderMenu.vue?vue&type=script&lang=js"

import "./TheHeaderMenu.vue?vue&type=style&index=0&id=597b6cd4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597b6cd4"]])

export default __exports__